<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-button class="m-3" variant="primary" @click="getReport">
          <div class="d-flex flex-column">
            <div style="font-size: 150px">
              <b-icon icon="file-earmark-text" />
            </div>
            <span class="my-5">Produtos</span>
          </div>
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapMutations } from "vuex";
import http from "../plugins/http";

export default {
  name: "exports",
  methods: {
    ...mapMutations(["setToasted"]),

    async getReport() {
      await http
        .get("/report", { responseType: "blob" })
        .then((res) => {
          const url = URL.createObjectURL(res.data);
          const a = document.createElement("a");

          a.href = url;
          a.download = `produto.xlsx`;
          a.click();
          a.remove();
          setTimeout(() => window.URL.revokeObjectURL(url), 100);

          this.setToasted({
            title: "Aguarde",
            message: "Relatório será enviado para seu email em instantes",
            variant: "success",
            visible: true,
          });
        })
        .catch(async (e) => {
          const text = await e.response.data.text();
          this.setToasted({
            title: "ERRO",
            message: JSON.parse(text).error,
            variant: "danger",
            visible: true,
          });
        });
    },
  },
};
</script>

<style></style>
